<template>
  <v-app class="home-page">
    <header-comp :activeButton="2" access="dealer" />

    <!-- <div class="">

      <v-col cols="12">
        <v-form ref="createEmp" lazy-validation class="btn-container">
          <v-text-field solo
            placeholder="Employee Name"
            type="text"
            v-model="empName"
            :rules="[rules.required]"
          ></v-text-field>
          <v-btn class="link-button ml-3" small color="primary" dark @click="createEmployee">
            {{ "create Employee" | translate }}</v-btn>
        </v-form>    
      </v-col>
      
      <v-col v-if="employeesData" cols="12" style="overflow: auto;">
        <v-data-table
          :headers="headers"
          :mobile="false"
          :items="employeesData"
          class="elevation-1"
        >
        <template v-slot:item.action="{ item }">
          <v-icon style="cursor: pointer" @click="deleteEmployee(item)">mdi-trash-can</v-icon>
        </template>
        <template v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td class="text-xs-right">{{ props.item.name }}</td>
        </template>
        </v-data-table>
      </v-col>
    </div> -->
  
    <v-card class="ma-3">
      <v-card-title style="background: gainsboro;">
        {{ "lng_employee_data_txt" | translate }}
        <v-spacer></v-spacer>
        <v-btn class="mx-2" fab dark small color="#0B7894" @click="openAddEmployeeModal = true">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-col cols="12" style="overflow: auto;" class="pa-0">
        <v-data-table
          :headers="headers"
          :items="employeesData"
          class="elevation-1"
          :loading="listLoading"
        >

          <template v-slot:item.action="{ item }">
            <v-icon style="cursor: pointer" @click="selectedItem = item; deleteEmployeeDialog = true">mdi-trash-can</v-icon>
          </template>
          <template v-slot:items="props">
            <td>{{ props.item.id }}</td>
            <td class="text-xs-right">{{ props.item.name }}</td>
          </template>
          
        </v-data-table>
      </v-col>
    </v-card>

    <AddEmployee
      :dealer-token="dealerToken"
      :dialog-title="'lng_add_employees_txt' | translate"
      :openDialog="openAddEmployeeModal"
      :closeDialog="closeAddEmployeeModalFunc"
      @saveSuccess="fetchEmployeesList(dealerToken)"
    />
    <v-dialog v-model="deleteEmployeeDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">{{ "lng_delete_confirmation_txt" | translate }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteEmployeeDialog = false">{{ "lng_no_txt" | translate }}</v-btn>
          <v-btn color="blue darken-1" text @click="deleteEmployee()">{{ "lng_yes_txt" | translate }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import HeaderComp from "../../components/HeaderComp";
import GlobalService from "../../services/global-service";
import { translateFunc } from '../../common/Filters';
import AddEmployee from "../../components/dealer/AddEmployee"

export default {
  name: "EmployeesList",
  components: {
    HeaderComp,
    AddEmployee
  },
  data(){
    return{
      rules: {
        required: value => !!value || translateFunc("lng_required_text"),
      },
      headers: [
        { text: 'Id', align: 'left', value: 'id'},
        { text: 'Full Name', value: 'name'},
        { text: 'Action', sortable: false, value: 'action'},
      ],
      dealerToken: undefined,
      employeesData: undefined,
      listLoading: false,
      empName: "",
      openAddEmployeeModal: false,
      deleteEmployeeDialog: false,
      selectedItem: undefined
    }
  },
  mounted(){
    let token = localStorage.getItem("userToken");
    this.dealerToken = token;
    this.listLoading = true;
    this.fetchEmployeesList(token);
  },
  methods: {
    async fetchEmployeesList(token) {
      let data = await GlobalService.getEmployeesList(token);
      if (data.employees) {
        this.employeesData = data.employees
        this.listLoading = false;
      }
    },
    async deleteEmployee(){
      if(this.selectedItem && this.selectedItem.id){
        let response = await GlobalService.deleteEmployee(this.dealerToken, this.selectedItem.id);
        if(response.status === 0){
          this.fetchEmployeesList(this.dealerToken);
          this.deleteEmployeeDialog = false;
        }
      }
      
    },
    createEmployee(){
      const that = this;
      this.$nextTick(async function() {
        if (that.$refs.createEmp.validate()) {
          let obj = { id: 2, name: this.empName }
          this.employeesData.push(obj);
          this.empName = "";
        }
      });
    },
    closeAddEmployeeModalFunc(){
      this.openAddEmployeeModal = false
    },
  }
}
</script>

<style>
.btn-container {
  display: flex;
  align-items: baseline;
  justify-content: center;
}
</style>